module.exports = __webpack_public_path__ + "21c4c598d141ae4379ed60a2bee4d18e.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-main-768.webp.png
// module id = 462
// module chunks = 0